module.exports = __webpack_public_path__ + "static/media/live-carousel-mobile-br.23239d4b.png";